<template>
    <header class="auth-header">
        <a 
            :href="landingLink" 
            target="_blank"
            class="to-landing to-landing_auth"
        >
            {{$t('nav.landing')}}
        </a>
        
        <img 
            v-if="$config.project == 'profy'" 
            src="@/assets/images/profy_logo.png"
            alt="logo" 
            width="67px"
        >
        <img 
            v-else
            src="@/assets/images/onGreen.svg"
            alt=""
        >
    </header>
</template>

<script>
export default {
    name: 'auth-header',
    computed: {
        landingLink() {
            return this.$config.project === 'profy' ? 'https://getprofy.de' : 'https://hilfy.at'
        }
    }
}
</script>

<style lang="scss" scoped>
.auth-header {
    width: 100%;
    height: 70px;
    background-color: #fff;
    box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.15);
    display: flex;
    justify-content: center;
    align-items: center;

    &__images {
        display: block;
        width: 76px;
        height: 32px;
    }
}

.to-landing_auth {
    position: absolute;
    left: 0%;
}

@media (max-width: 768px) {
    .to-landing_auth {
        display: block !important;
        margin-left: 10px;
        font-size: 14px;
    }
}
</style>